module.exports = {
  ConfigRouter: require('./components/ConfigRouter'),
  ConfigCard: require('./components/ConfigCard'),
  LimitsCard: require('./components/LimitsCard'),
  NotificationForm: require('./components/NotificationForm'),
  WalletsList: require('./components/WalletsList'),
  TrxProcessingForm: require('./components/TrxProcessingForm'),
}
